// services/deepseek.js
import OpenAI from "openai";
import { notification } from 'antd';

// 创建并直接导出对象
export const deepseekService = {
    client: new OpenAI({
        baseURL: process.env.REACT_APP_DEEPSEEK_API_BASE_URL,
        apiKey: process.env.REACT_APP_DEEPSEEK_API_KEY,
        dangerouslyAllowBrowser: true, // 允许在浏览器中使用API密钥
    }),

    async sendMessage(message, conversationId) {
        try {
            const response = await this.client.chat.completions.create({
                messages: [{ role: "user", content: message }],
                model: "deepseek-chat",
                temperature: 0.7, // 控制随机性
                max_tokens: 2000, // 最大token数
                conversation_id: conversationId // 保持会话连续性
            });
            return {
                success: true,
                reply: response.choices[0].message.content,
                conversationId: response.id || conversationId
            };
        } catch (error) {
            console.log('Deepseek API Error:', error);
            notification.error({
                message: '错误提示',
                description: 'AI服务暂时不可用',
                duration: 4.5,
            });
            throw new Error('AI服务暂时不可用');
        }
    },
};